import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Sidebar = styled.div`
  z-index: 9999;
  position: absolute;
  top: 0;
  right: -256px;
  //height: calc(100vh - 65px);
  //max-height: calc(100vh - 65px);
  //overflow-y: auto;
  width: 256px;
  background-color: ${Variables.colors.complementary};
  border-left: 1px solid ${Variables.colors.complementary_400};
  direction: ltr;
  text-align: right;

  ul.sidebar-list {
    padding: 13px 0 0 8px;
    margin: 8px 0 0 0;
    direction: rtl;
    min-height: calc(100vh - 155px);
    a {
      color: ${Variables.colors.complementary_900};
      text-decoration: none;
      &:hover,
      &:active,
      &:visited {
        color: ${Variables.colors.complementary_900};
      }
      .sidebar-disabled-link {
        cursor: not-allowed !important;
      }
      li {
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        list-style: none;
        text-align: right;
        direction: rtl;
        font-size: ${Variables.font_sizes.x_small};
        position: relative;
        width: auto;
        height: 32px;
        margin: auto;
        padding: 8px 26px 8px 0;
        border-radius: unset;

        .premium {
          margin-right: 8px;
          &:before {
            color: ${Variables.colors.yellow_500};
          }
        }

        .sidebar-badge {
          display: none;
          position: absolute;
          top: 8px;
          left: 8px;
          width: 16px;
          height: 16px;
          i.external-link-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 16px;
            &:before {
              margin: 0;
              font-size: 16px;
              color: ${Variables.colors.complementary_500};
            }
          }
        }

        i {
          &:before {
            color: ${Variables.colors.complementary_600};
            margin-left: 9px;
            font-size: 18px;
          }
        }

        &:hover {
          background-color: ${Variables.colors.complementary_200};
          border-radius: 4px;
          padding: 8px 26px 8px 0;
          .sidebar-badge {
            display: block;
          }
        }
      }
    }
    a.list-item-active {
      li {
        background-color: ${Variables.colors.primary_50};
        color: ${Variables.colors.primary_vivid};
        &:hover,
        &:active,
        &:visited {
          color: ${Variables.colors.primary_vivid};
        }
        border-radius: 4px 0 0 4px;
        padding: 8px 26px 8px 0;
        i {
          &:before {
            color: ${Variables.colors.primary_vivid};
          }
        }
      }
    }
  }
  .sidebar-footer {
    margin-right: 12px;
    padding: 20px 11px 0 0;
    direction: rtl;
    text-align: right;
    height: 80px;
    background-color: ${Variables.colors.complementary};
    a {
      text-decoration: none;
      color: ${Variables.colors.complementary_600};
      &:hover,
      &:visited,
      &:focus {
        color: ${Variables.colors.complementary_600};
      }
    }
    .circle-separator {
      width: 4px;
      height: 4px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 2px;
      content: " ";
      border-radius: 50%;
      background-color: ${Variables.colors.complementary_700};
    }
    div {
      color: ${Variables.colors.complementary_600};
      font-size: ${Variables.font_sizes.x_small};
      padding-bottom: 7px;
    }
  }
`;

export const Separator = styled.li`
  width: 100%;
  height: 1px;
  background-color: ${Variables.colors.complementary_400};
  margin: 10px auto;
`;
